var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.794,
    height: 24,
    viewBox: "0 0 18.794 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.794,
    height: 24,
    fill: "#595959"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.584,56.4H3.641a1.916,1.916,0,0,1-1.916-1.916V36.917a1.913,1.913,0,0,1,.066-.49A1.915,1.915,0,0,0,0,38.337V55.9a1.916,1.916,0,0,0,1.916,1.916H13.86a1.915,1.915,0,0,0,1.851-1.426c-.042,0-.084.006-.126.006",
    transform: "translate(0 -33.817)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.609,7.326h-7.155V0Z",
    transform: "translate(-150.816 0)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.88,8.192H49.823V0H44.035a1.916,1.916,0,0,0-1.916,1.916V19.481A1.916,1.916,0,0,0,44.035,21.4H55.979a1.916,1.916,0,0,0,1.916-1.916V8.208Zm-6.016,9.793a.7.7,0,0,1-.695.695H45.51a.7.7,0,0,1-.695-.695v-.427a.7.7,0,0,1,.695-.695h5.659a.7.7,0,0,1,.695.695ZM55.2,14.873a.843.843,0,0,1-.843.843h-8.7a.843.843,0,0,1-.843-.843v-.13a.843.843,0,0,1,.843-.843h8.7a.843.843,0,0,1,.843.843Zm0-2.964a.843.843,0,0,1-.843.843h-8.7a.843.843,0,0,1-.843-.843v-.13a.843.843,0,0,1,.843-.843h8.7a.843.843,0,0,1,.843.843Z",
    transform: "translate(-39.101 -0.001)",
    fill: "#595959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/Assets.4a4001e3cef55219d54011528c47a410.svg";
export { ForwardRef as ReactComponent };